// Toggle für das "Passwort anzeigen"-Feld im gebrandeten Passwort-Login
// (siehe Classes/Setup/PasswordFormSetup.php). Wird über main.ts ins bereits
// sitewide enqueue'te Bundle gehängt -> CSP-konform, kein Inline-Script.

const toggleButtons =
  document.querySelectorAll<HTMLButtonElement>('[data-password-toggle]')

for (const btn of toggleButtons) {
  const targetSelector = btn.dataset.passwordToggle
  if (!targetSelector) {
    continue
  }

  const input = document.querySelector<HTMLInputElement>(targetSelector)
  if (!input) {
    continue
  }

  const openEye = btn.querySelector<SVGElement>('.password-gate__eye--open')
  const closedEye = btn.querySelector<SVGElement>('.password-gate__eye--closed')

  // Icon-Sichtbarkeit direkt per Inline-Style steuern (unabhängig von der
  // CSS-Pipeline). Start: offenes Auge sichtbar (Passwort verdeckt).
  const renderIcons = (isVisible: boolean) => {
    if (openEye) {
      openEye.style.display = isVisible ? 'none' : 'block'
    }
    if (closedEye) {
      closedEye.style.display = isVisible ? 'block' : 'none'
    }
  }

  renderIcons(false)

  btn.addEventListener('click', () => {
    const willShow = input.type === 'password'
    input.type = willShow ? 'text' : 'password'
    btn.setAttribute('aria-pressed', String(willShow))
    btn.classList.toggle('password-gate__toggle--visible', willShow)
    renderIcons(willShow)

    const label = willShow ? btn.dataset.labelHide : btn.dataset.labelShow
    if (label) {
      btn.setAttribute('aria-label', label)
      btn.setAttribute('title', label)
    }

    // Fokus im Feld halten, Cursor ans Ende
    const end = input.value.length
    input.focus()
    input.setSelectionRange(end, end)
  })
}
